export default __webpack_public_path__ + "images/curl_q80.webp";